import React, { Component } from "react";
import { connect } from "react-redux";
import { Column, Row } from "@sm/helpers/simple-flexbox";
import { Panel } from "react-bootstrap";

import CustomButton from "@sm/components/custom/Button";
import Form from "@sm/core/Form";
import Select from "@sm/components/custom/Select";
import Spinner from "@sm/components/Spinner";

import "@assets/css/blacklist.css";
import UserManagementIcon from "@assets/images/user-management.png";

import * as actions from "@sm/actions";
import { FETCH_PERMISSIONS } from "@sm/actions/types";
import { crudActions } from "@sm/services/crudActions";
const store =  require("@sm/reducers/index");

class AddBlacklist extends Component {
  state = {
    controls: new Form({
      companyId: "",
      merchantId: ""
    }, [{
      name: "companyId",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "merchantId",
      type: "isString",
      rules: {
        required: true
      }
    }]),
    companies: [],
    blacklist: [],
    defaultFormFields: {
      email: "",
      firstName: "",
      lastName: "",
      ipAddress: "",
      mobileNumber: ""
    },
    defaultFormRules: [{
      name: "email",
      type: "isEmail",
      rules: {
        required: true
      }
    }, {
      name: "firstName",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "lastName",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "ipAddress",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "mobileNumber",
      type: "isString",
      rules: {
        required: false
      }
    }],
    access: [],
    isLoading: true,
    isSaveClicked: false
  };

  subscribeFunction = null;

  componentDidMount() {
    const storeState = store.default.getState().authReducer;
    if (storeState.access) {
      this.setState({
        access: storeState.access
      });
    }

    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().authReducer;

      if (state.userUpdate === FETCH_PERMISSIONS) {
        this.setState({
          access: state.access
        });
      }
    });

    Promise.all([
      crudActions.get(`v1/companies/clients`),
    ]).then(
      data => {
        const companiesData = data[0];
        if (companiesData) {
          const { blacklist, defaultFormFields, defaultFormRules } = this.state;
          blacklist.push(new Form(defaultFormFields, defaultFormRules));
          const companies = companiesData.map(elem => elem.company);
          companies.sort((elemA, elemB) => elemA.label.localeCompare(elemB.label));

          this.setState({
            companies: companies,
            controls: Object.assign(this.state.controls, { companyId: companies[0] ? companies[0].value : "" }),
            companiesClients: companiesData.reduce((accumulator, currentElem) => {
              accumulator[currentElem.company.value] = currentElem.clients.map(elem => elem.client);
              return accumulator;
            }, {}),
            blacklist,
            isLoading: false
          }, () => {
            const { controls } = this.state;
            if (controls.companyId) {
              if (companies[0]) {
                this.onValueChange(companies[0], 'companyId');
              }
            }
          });
        }
      }
    );
  };

  componentWillUnmount() {
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  };

  onValueChange = (event, field) => {
    let { merchantOptions } = this.state;
    const { controls, companiesClients, isSaveClicked } = this.state;
    if (!event) {
      controls[field] = event;
    } else if (event.target) {
      controls[field] = event.target.value;
    } else if (event.value) {
      controls[field] = event.value;
    } else {
      controls[field] = event.map(elem => elem.value);
    }

    if (field === "companyId") {
      const company = controls[field];
      if (company) {
        merchantOptions = companiesClients[company];
        controls.merchantId = merchantOptions[0]?.value;
      }
    }

    if (isSaveClicked) {
      controls.isFormValid();
    }

    this.setState({
      controls,
      merchantOptions
    });
  };

  onBlacklistValueChange = (event, index, field) => {
    const { blacklist } = this.state;
    blacklist[index][field] = event.target.value;

    blacklist.forEach(form => {
      form.isFormValid();
    });

    this.setState({
      blacklist
    });
  };

  onDeleteItem = (index) => {
    const { blacklist } = this.state;
    blacklist.splice(index, 1); 
    this.setState({
      blacklist
    });
  };

  onAddItem = () => {
    const { blacklist, defaultFormFields, defaultFormRules } = this.state;
    blacklist.push(new Form(defaultFormFields, defaultFormRules)); 
    this.setState({
      blacklist
    });
  };

  onBlacklistSave = () => {
    const { blacklist, controls, defaultFormFields, defaultFormRules } = this.state;
    const isControlsFormValid = controls.isFormValid();
    let isBlacklistFormsValid = true;

    blacklist.forEach(form => {
      form.isFormValid();
      if (!form.isFormValid()) {
        isBlacklistFormsValid = false;
      }
    });

    this.setState({
      blacklist,
      controls,
      isSaveClicked: true
    });

    if (isControlsFormValid && isBlacklistFormsValid) {
      this.setState({
        isLoading: true
      });
      var toStore = blacklist.map(num => {
        return {
          email: num.email,
          firstName: num.firstName,
          lastName: num.lastName,
          ipAddress: num.ipAddress,
          mobileNumber: num.mobileNumber,
          merchantId: controls.merchantId
        };
      });

      crudActions.post(`v1/blacklist/store`, {
        toStore: toStore,
      }).then(
        (result) => {
          this.setState({
            blacklist: [new Form(defaultFormFields, defaultFormRules)],
            isLoading: false
          });
          this.props.showAlert(true, "success", "Added to blacklist successfully!");
        }
      ).catch(
        err => {
          if (err && err.message) {
            this.setState({
              isLoading: false
            });
            this.props.showAlert(true, "error", err.message);
          }
        }
      );
    }
  };

  render() {
    const {
      blacklist,
      companies,
      controls,
      isLoading,
      merchantOptions   
    } = this.state;

    return (
      <Row flexGrow={ 1 } className="module blacklist" vertical='start'>
        <Column flexGrow={ 1 }>
          <Row className="header" flexGrow={ 1 } horizontal='space-between' vertical='center'>
            <Column>
              <Row horizontal='center' vertical='center' style={ { paddingLeft: 15 } }>
                <img src={ UserManagementIcon } alt="" style={ { marginRight: 10 } }/>
                Blacklist
              </Row>
            </Column>
          </Row>
          <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='start'>
            <Column flexGrow={ 1 } vertical='start' className="panel-block">
              <Panel>
                <Panel.Heading>
                  <Panel.Title>
                    ADD USER TO BLACKLIST
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  { isLoading ? (
                    <div style={ { width: "100%", height: "400px", display: "flex", alignItems: "center", justifyContent: "center" } }>
                      <Spinner smallContainer={ true } />
                    </div>
                  ) : (
                    <div className="panel-content" style={ {overflow: 'unset'} }>
                      <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' style={ { width: '100%', marginBottom: '25px' } }>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <label> White Label </label>
                          <Select
                            id="companyId"
                            name="companyId"
                            className={ controls.errors.has('companyId') ? 'error-field' : "" }
                            value={ controls.companyId || '' }
                            required={ true }
                            clearable={ true }
                            onChange={ (value) => this.onValueChange(value, 'companyId') }
                            options={ companies }
                          />
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <label> Merchant </label>
                          <Select
                            id="merchantId"
                            name="merchantId"
                            className={ controls.errors.has('merchantId') ? 'error-field' : "" }
                            value={ controls.merchantId || '' }
                            required={ true }
                            clearable={ true }
                            onChange={ (value) => this.onValueChange(value, 'merchantId') }
                            options={ merchantOptions }
                          />
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <span/>
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <span/>
                        </Column>
                      </Row>
                      { blacklist.map((blForm, i) => 
                        <Row key={ i } flexGrow={ 1 } wrap={ true } horizontal='start' vertical='center' className="blacklist-add-form">
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Email </label>
                            <input
                              type="text"
                              className={ "form-control " + (blForm.errors.has('email') ? 'error-field' : "") }
                              value={  blForm.email }
                              onChange={ (e) => this.onBlacklistValueChange(e, i, "email") }
                            />
                            { blForm.errors.has('email') && <p className="error-message"> { blForm.errors.get('email')} </p>}
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> First Name </label>
                            <input
                              type="text"
                              className={ "form-control " + (blForm.errors.has('firstName') ? 'error-field' : "") }
                              value={  blForm.firstName }
                              onChange={ (e) => this.onBlacklistValueChange(e, i, "firstName") }
                            />
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Last Name </label>
                            <input
                              type="text"
                              className={ "form-control " + (blForm.errors.has('lastName') ? 'error-field' : "") }
                              value={  blForm.lastName }
                              onChange={ (e) => this.onBlacklistValueChange(e, i, "lastName") }
                            />
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Phone Number </label>
                            <input
                              type="text"
                              className={ "form-control " + (blForm.errors.has('mobileNumber') ? 'error-field' : "") }
                              value={  blForm.mobileNumber }
                              onChange={ (e) => this.onBlacklistValueChange(e, i, "mobileNumber") }
                            />
                          </Column>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> IP Address </label>
                            <input
                              type="text"
                              className={ "form-control " + (blForm.errors.has('ipAddress') ? 'error-field' : "") }
                              value={ blForm.ipAddress }
                              onChange={ (e) => this.onBlacklistValueChange(e, i, "ipAddress") }
                            />
                          </Column>
                          <Column className="actions" style={ { flexDirection: "row" } }>
                            <button
                              className="delete"
                              onClick={ () => this.onDeleteItem(i) }
                            >
                              X
                            </button>
                            <button
                              className={ `add ${i !== blacklist.length - 1 && 'add-hidden'}` }
                              onClick={ () => this.onAddItem() }
                            >
                              <span className="plus"> + </span>
                            </button>
                          </Column>
                        </Row>
                      )}
                      <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end' style={ { width: '100%' } }>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <span/>
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <span/>
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <span/>
                        </Column>
                        <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                          <label/>
                          <CustomButton
                            title="Save"
                            type="button"
                            onClick={ (e) => this.onBlacklistSave() }
                          />
                        </Column>                 
                      </Row>
                    </div>
                  )}
                </Panel.Body>
              </Panel>
            </Column>
          </Row>
        </Column>

      </Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert
  };
};

export default connect(mapStateToProps, actions)(AddBlacklist);
